"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _default = {
  PropTypes: {
    isTwoWay: _propTypes.default.bool,
    isMobile: _propTypes.default.bool,
    departConfig: _propTypes.default.object,
    returnConfig: _propTypes.default.object,
    dateFormatData: _propTypes.default.object,
    onDepartClick: _propTypes.default.func,
    onReturnClick: _propTypes.default.func,
    hideIcon: _propTypes.default.bool,
    partialDivider: _propTypes.default.bool,
    labels: _propTypes.default.object,
    theme: _propTypes.default.string,
    selectingDepart: _propTypes.default.bool,
    selectingReturn: _propTypes.default.bool,
    modalOpen: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME
  }
};
exports.default = _default;